import { lazy } from "react";
export const HomePage = lazy(() => import("src/pages/HomePage"));
export const CareerPage = lazy(() => import("src/pages/Careeres"));
export const CareerDetailPage = lazy(() => import("src/pages/CareeresDetail"));
export const ProductPage = lazy(() => import("src/pages/Products"));
export const TeamPage = lazy(() => import("src/pages/Team"));
